import { FC } from 'react';
import cx from 'classnames';

import SanityImage from 'atoms/SanityImage';
import ImageCaption from 'atoms/ImageCaption';

import VideoBlock from 'atoms/Video';

import { ImageGridBlock as ImageGridBlockType } from 'lib/sanity/types';

export interface Props {
  block: ImageGridBlockType;
  isCaseStudy?: Boolean;
  isFromSnippet?: boolean;
}

const ImageGridBlock: FC<Props> = ({ block, isCaseStudy, isFromSnippet }) => {
  const { imageGridRows } = block;

  if (!imageGridRows) {
    return <></>;
  }

  return (
    <div className="ImageGridBlock w-full flex flex-col space-y-6">
      {imageGridRows?.map((imageGridRow) => {
        const { numberOfColumns, images } = imageGridRow;
        return (
          <div
            key={imageGridRows.indexOf(imageGridRow)}
            className={cx(
              'px-0 laptop:px-content-narrow grid grid-cols-1 gap-6 w-full',
              {
                'laptop:grid-cols-2': numberOfColumns === 2,
                'laptop:grid-cols-4': numberOfColumns === 4,
              },
            )}
          >
            {images?.map((image, i) => {
              return (
                <div
                  key={image._key}
                  className={cx(
                    'flex flex-col space-y-4 laptop:space-y-6 px-4 laptop:px-0',
                  )}
                >
                  {image._type == 'imageFieldWithCaption' && (
                    <>
                      <SanityImage
                        className="ImageGridBlock__single-image"
                        blur={block.snippet || isFromSnippet ? false : true}
                        {...image}
                      />
                      <ImageCaption
                        title={image.captionTitle}
                        description={image.captionDescription}
                        singleColumn={imageGridRow.numberOfColumns === 1}
                        isCaseStudy={isCaseStudy}
                        className={cx({
                          'pb-4': i !== images.length - 1,
                        })}
                      />
                    </>
                  )}
                  {image._type == 'videoField' && (
                    <VideoBlock
                      media={image}
                      isHorizontal={
                        numberOfColumns ===
                        1 /* video will be displayed horizontal if it is rendered in a single column, otherwise, it will be rendered as vertical image */
                      }
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ImageGridBlock;
